import { useAuthenticated } from './useAuthenticated';

export function useAuthenticatedUser() {
  const { userContext } = useAuthenticated();
  return userContext.authenticatedUser;
}
